export const CAPABILITIES = [
  {
    id: 'vision',
    label: 'Vision',
    claim: 'Detection, tracking, and biometrics that run on real cameras — not just benchmarks.',
    stack: ['OpenCV', 'YOLO', 'TensorFlow', 'Custom CNNs'],
    demos: [
      { id: 12, title: 'Face Detection & Recognition', video: '/assets/videos/Face-Detection-Recognition.mp4' },
      { id: 13, title: 'Anti-Spoof Detection', video: '/assets/videos/AntispoofDetection.mp4' },
      { id: 4, title: 'ANPR', video: '/assets/videos/AutomaticNumberPlateDetection-ANPR.mp4' },
    ],
    portfolioFilter: 'vision',
  },
  {
    id: 'language',
    label: 'Language',
    claim: 'LLMs wired into workflows — chat, matching, content, and decisions that operators can trust.',
    stack: ['NLP', 'GPT Models', 'RAG', 'Integrations'],
    demos: [
      { id: 10, title: 'WebChat', video: '/assets/videos/WebChat-Chat-with-Websites.mp4' },
      { id: 11, title: 'ContentVerse', video: '/assets/videos/Content_Verse.mp4' },
      { id: 16, title: 'Candidate–Job Matching', video: '/assets/videos/CaniddateJobMaching.mp4' },
    ],
    portfolioFilter: 'llm',
  },
  {
    id: 'multimodal',
    label: 'Multimodal',
    claim: 'Systems that see and speak — VLMs, avatars, and image-grounded answers.',
    stack: ['CLIP', 'VLM', 'Lip Sync', 'PyTorch'],
    demos: [
      { id: 17, title: 'Visual QA', image: '/assets/images/samples/visual-qa-dataset.jpg', isImage: true, alt: 'Sample Visual QA dataset categories' },
      { id: 7, title: 'AI Avatar — Acting', video: '/assets/videos/AI_Avatar-Acting.mp4' },
      { id: 9, title: 'AI Avatar — Singing', video: '/assets/videos/AI_Avatar-Sing.mp4' },
    ],
    portfolioFilter: 'vlm',
  },
  {
    id: 'systems',
    label: 'Systems',
    claim: 'Production rails: surveillance stacks, traffic ops, and end-to-end pipelines that stay up.',
    stack: ['Python', 'Real-time', 'Edge + Cloud', 'APIs'],
    demos: [
      { id: 1, title: 'Detection & Tracking', video: '/assets/videos/AdvancedDetectiionAndTracking.mp4' },
      { id: 5, title: 'Traffic Violation', video: '/assets/videos/Traffic_Violation.mp4' },
      { id: 6, title: 'Crowd Counting', video: '/assets/videos/CrowdDetectionTracking-Counting.mp4' },
    ],
    portfolioFilter: 'systems',
  },
];

export const STACK_LAYERS = [
  { id: 'sense', title: 'Sense', detail: 'Cameras, documents, chat, and sensors as clean inputs.' },
  { id: 'model', title: 'Model', detail: 'Vision, language, and multimodal models tuned to your domain.' },
  { id: 'decide', title: 'Decide', detail: 'Rules, scoring, and LLM-assisted workflows for operators.' },
  { id: 'ship', title: 'Ship', detail: 'APIs, dashboards, edge deploy, and monitoring that lasts.' },
];

export const FAQ_ITEMS = [
  {
    q: 'Are your engineers senior, or do juniors carry delivery?',
    a: 'Delivery is led by engineers who have shipped vision and LLM systems in production. We staff for ownership, not seat-filling.',
  },
  {
    q: 'Can you rescue a failing model or legacy pipeline?',
    a: 'Yes. We audit data, latency, and failure modes first — then harden or replace what is broken.',
  },
  {
    q: 'How fast can you start?',
    a: 'We aim for a discovery call within a few business days. A scoped pilot can begin once data access and success metrics are clear — often within a couple of weeks.',
  },
  {
    q: 'Do you only build computer vision?',
    a: 'No. Vision is a strength, but we also ship conversational AI, VLMs, avatars, and decision systems when the product needs them.',
  },
  {
    q: 'Will we own the IP and models?',
    a: 'Yes. Work product, custom models, and integrations are yours unless we agree otherwise in writing.',
  },
];

export const ENGAGE_STEPS = [
  { n: '01', title: 'Scope', text: 'One problem, clear metrics, real data paths.' },
  { n: '02', title: 'Build', text: 'Ship a thin vertical slice you can demo and measure.' },
  { n: '03', title: 'Harden', text: 'Latency, edge cases, monitoring — then scale.' },
];
